import i18n from "../../../services/localization-service/i18n";
import { ReportScheduleRecipientType } from "../ScheduledReportsEditorUtils";
import { BaseActions, ActionMenuItem } from "../../action-menu/ActionMenuItem";
import { AddIcon } from "../../action-menu/ActionMenuIcons";


export enum RecipientActions  {
    Add = 'add',
}

export type RecipientActionItem = {
    action: RecipientActions | BaseActions | string
} & ActionMenuItem;

export const recipientActionItems: RecipientActionItem[] = [{
    label: i18n.t("buttons.newRecipient"),
    icon: AddIcon,
    action: RecipientActions.Add,
    order: 0
}];


const ScheduledReportsNotificationUtils = {
    //move to utils
    filterRecipients: (data: ReportScheduleRecipientType[], 
        filter: string,
        organizationID: number | undefined,
        viewSelected: boolean
    ) : ReportScheduleRecipientType[] => {

        const items = viewSelected ? data.filter(o => o.selected) : data;

        return items.filter(o => (filter.trim() === '' ||
                                o.address.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1) && 
                                (organizationID === undefined || o.organizationID === organizationID));
    }    
}

export default ScheduledReportsNotificationUtils;